<!-- Add/Edit custom fields -->
<form [formGroup]="customForm" class="p-field p-grid p-mb-0" *ngIf="isEdit; else viewBlock" autocomplete="off">
    <ng-container *ngFor="let field of templateCustomFields" >
        <div *ngIf="!['Formula'].includes(field.formControl?.type) && field.enabledInForm" class="p-col-12 p-lg-6 p-mb-2 p-mt-2" [ngClass]="{'p-lg-12': ['Multi-Line','RichText'].includes(field.formControl?.type)}">
            <ng-container [ngSwitch]="field.formControl?.type">
                <label class="p-mb-2">
                    {{ field.labelName }}
                    @if(field.description){
                        <i class="pi pi-info-circle p-mr-2 info-icon-tooltip"
                           pTooltip="{{field.description}}"
                           tooltipPosition="top">
                        </i>
                    }
                    <span style="color: red;" *ngIf="field.isRequired"> * </span>
                    <i *ngIf="['FileUpload'].includes(field.formControl?.type)" class="pi pi-exclamation-circle p-ml-1" [escape]="false" [pTooltip]="multiLineTooltipFile" tooltipPosition="top"></i>
                    <i *ngIf="['Picture'].includes(field.formControl?.type)" class="pi pi-exclamation-circle p-ml-1" [escape]="false" [pTooltip]="multiLineTooltipPicture" tooltipPosition="top"></i>
                </label>

                <!-- Input -->
                <ng-container *ngSwitchCase="'InputBox'">
                    <input pInputText type="text" [formControlName]="field.name"
                        (ngModelChange)="onSetCustomFieldValue(field.customAttributeId, customForm.get(field.name).value)" />
                    <div class="p-mt-1">
                        <small id="error-help" class="custom-fields-error-{{tabIndex}} p-invalid" *ngIf="isRequiredTouched(field.name)">
                            {{ field.labelName }} is required
                        </small>
                    </div>
                </ng-container>

                <!-- AutoNumber -->
                <ng-container *ngSwitchCase="'AutoNumber'">
                    <input pInputText type="text" [formControlName]="field.name" [disabled]="true" [readonly]="true" class="p-disabled"
                        placeholder="This field value will be auto generated"
                        (ngModelChange)="onSetCustomFieldValue(field.customAttributeId, customForm.get(field.name).value)" />
                </ng-container>

                <!-- Multi-Line -->
                <ng-container *ngSwitchCase="'Multi-Line'">
                    <textarea pInputTextarea type="text" [formControlName]="field.name" rows="5"
                        (ngModelChange)="onSetCustomFieldValue(field.customAttributeId, customForm.get(field.name).value)"></textarea>
                    <div class="p-mt-1">
                        <small id="error-help" class="custom-fields-error-{{tabIndex}} p-invalid" *ngIf="isRequiredTouched(field.name)">
                            {{ field.labelName }} is required
                        </small>
                    </div>
                </ng-container>

                <!-- RichText -->
                <ng-container *ngSwitchCase="'RichText'">
                    <p-editor #editor [style]="{'height: auto, min-height':'100px'}" [formControlName]="field.name" rows="5"
                    (ngModelChange)="onSetCustomFieldValue(field.customAttributeId, customForm.get(field.name).value)">
                        <p-header>
                            <span class="ql-formats">
                                <select class="ql-size">
                                    <option value="small">small</option>
                                    <option selected></option>
                                    <option value="large">large</option>
                                    <option value="huge">huge</option>
                                </select>
                            </span>
                            <span class="ql-formats">
                                <button class="ql-bold" aria-label="Bold"></button>
                                <button class="ql-italic" aria-label="Italic"></button>
                                <button class="ql-underline" aria-label="Underline"></button>
                                <button class="ql-strike" aria-label="Strike"></button>
                            </span>
                            <span class="ql-formats">
                                <select title="Text Color" class="ql-color"></select>
                                <span class="ql-format-separator"></span>
                                <select title="Background Color" class="ql-background"></select>
                            </span>
                            <span class="ql-formats">
                                <button class="ql-list" value="ordered"></button>
                                <button class="ql-list" value="bullet"></button>
                                <select title="Text Alignment" class="ql-align">
                                    <option selected>Gauche</option>
                                    <option value="center" label="Center"></option>
                                    <option value="right" label="Right"></option>
                                    <option value="justify" label="Justify"></option>
                                </select>
                            </span>
                            <span class="ql-formats">
                                <button aria-label="Link" class="ql-link"></button>
                            </span>
                        </p-header>
                    </p-editor>
                    <div class="p-mt-1">
                        <small id="error-help" class="custom-fields-error-{{tabIndex}} p-invalid" *ngIf="isRequiredTouched(field.name)">
                            {{ field.labelName }} is required
                        </small>
                    </div>
                </ng-container>

                <!-- Email -->
                <ng-container *ngSwitchCase="'Email'">
                    <input pInputText type="text" [formControlName]="field.name"
                        (ngModelChange)="onSetCustomFieldValue(field.customAttributeId, customForm.get(field.name).value)" />
                    <div class="p-mt-1">
                        <small id="error-help" class="custom-fields-error-{{tabIndex}} p-invalid" *ngIf="isRequiredTouched(field.name)">
                            {{ field.labelName }} is required
                        </small>
                        <small id="error-help" class="custom-fields-error-{{tabIndex}} p-invalid" *ngIf="isPatternInvalid(field.name)">
                            Please enter a valid Email
                        </small>
                    </div>
                </ng-container>

                <!-- Phone -->
                <ng-container *ngSwitchCase="'Phone'">
                    <input pInputText type="text" [formControlName]="field.name" (ngModelChange)="onSetCustomFieldValue(field.customAttributeId, customForm.get(field.name).value)" />
                    <div class="p-mt-1">
                        <small id="error-help" class="custom-fields-error-{{tabIndex}} p-invalid" *ngIf="isRequiredTouched(field.name)">
                            {{ field.labelName }} is required
                        </small>
                        <small id="error-help" class="custom-fields-error-{{tabIndex}} p-invalid" *ngIf="isPatternInvalid(field.name)">
                            Please enter a valid Phone
                        </small>
                    </div>
                </ng-container>

                <!-- IPAddress -->
                <ng-container *ngSwitchCase="'IPAddress'">
                    <input pInputText type="text" [formControlName]="field.name" (ngModelChange)="onSetCustomFieldValue(field.customAttributeId, customForm.get(field.name).value)" />
                    <div class="p-mt-1">
                        <small id="error-help" class="custom-fields-error-{{tabIndex}} p-invalid" *ngIf="isRequiredTouched(field.name)">
                            {{ field.labelName }} is required
                        </small>
                        <small id="error-help" class="custom-fields-error-{{tabIndex}} p-invalid" *ngIf="isPatternInvalid(field.name)">
                            Please enter a valid IP Address
                        </small>
                    </div>
                </ng-container>

                <!-- URL -->
                <ng-container *ngSwitchCase="'URL'">
                    <input pInputText type="text" [formControlName]="field.name" placeholder="Enter URL with http/https"
                        (ngModelChange)="onSetCustomFieldValue(field.customAttributeId, customForm.get(field.name).value)" />
                    <div class="p-mt-1">
                        <small id="error-help" class="custom-fields-error-{{tabIndex}} p-invalid" *ngIf="isRequiredTouched(field.name)">
                            {{ field.labelName }} is required
                        </small>
                        <small id="error-help" class="custom-fields-error-{{tabIndex}} p-invalid" *ngIf="isPatternInvalid(field.name)">
                            Please enter a valid URL
                        </small>
                    </div>
                </ng-container>

                <!-- Barcode -->
                <ng-container *ngSwitchCase="'Barcode'">
                    <input pInputText type="text" [formControlName]="field.name"
                        (ngModelChange)="onSetCustomFieldValue(field.customAttributeId, customForm.get(field.name).value)" />
                    <div class="p-mt-1">
                        <small id="error-help" class="custom-fields-error-{{tabIndex}} p-invalid" *ngIf="isRequiredTouched(field.name)">
                            {{ field.labelName }} is required
                        </small>
                        <small id="error-help" class="custom-fields-error-{{tabIndex}} p-invalid" *ngIf="isPatternInvalid(field.name)">
                            Please enter a valid Barcode
                        </small>
                    </div>
                </ng-container>

                <!-- EncryptedText -->
                <ng-container *ngSwitchCase="'EncryptedText'">

                    <p-iconField iconPosition="right">
                        <p-inputIcon *ngIf="field?.show" styleClass="pi pi-eye" (click)="field['show']=!field['show']" />
                        <p-inputIcon *ngIf="!field?.show" styleClass="pi pi-eye-slash" (click)="field['show']=!field['show']"/>
                        <input pInputText [formControlName]="field.name" [type]="'text'" [style]="!field['show'] ? '-webkit-text-security: disc;':''"
                            (ngModelChange)="onSetCustomFieldValue(field.customAttributeId, customForm.get(field.name).value)" />
                    </p-iconField>

                    <div class="p-mt-1">
                        <small id="error-help" class="custom-fields-error-{{tabIndex}} p-invalid" *ngIf="isRequiredTouched(field.name)">
                            {{ field.labelName }} is required
                        </small>
                        <small id="error-help" class="custom-fields-error-{{tabIndex}} p-invalid" *ngIf="isPatternInvalid(field.name)">
                            Encryption text is not valid
                        </small>
                    </div>
                </ng-container>

                <!-- Time -->
                <ng-container *ngSwitchCase="'Time'">
                    <input pInputText type="time" [formControlName]="field.name"
                        (ngModelChange)="onSetCustomFieldValue(field.customAttributeId, customForm.get(field.name).value)" />
                    <div class="p-mt-1">
                        <small id="error-help" class="custom-fields-error-{{tabIndex}} p-invalid" *ngIf="isRequiredTouched(field.name)">
                            {{ field.labelName }} is required
                        </small>
                    </div>
                </ng-container>

                <!-- Number -->
                <ng-container *ngSwitchCase="'Number'">
                    <p-inputNumber
                        [formControlName]="field.name"
                        (ngModelChange)="onSetCustomFieldValue(field.customAttributeId, customForm.get(field.name).value)"
                        (keypress)="isNumberKey($event)">
                    </p-inputNumber>
                    <div class="p-mt-1">
                        <small id="error-help" class="custom-fields-error-{{tabIndex}} p-invalid" *ngIf="isRequiredTouched(field.name)">
                            {{ field.labelName }} is required
                        </small>
                    </div>
                </ng-container>

                <!-- Percentage -->
                <ng-container *ngSwitchCase="'Percentage'">
                    <p-inputNumber
                        [formControlName]="field.name" placeholder="%"
                        (ngModelChange)="onSetCustomFieldValue(field.customAttributeId, customForm.get(field.name).value)"
                        [minFractionDigits]="0" [maxFractionDigits]="(field?.formControl?.maxLengthAfterDecimal||field?.maxLengthAfterDecimal||6)">
                    </p-inputNumber>
                    <div class="p-mt-1">
                        <small id="error-help" class="custom-fields-error-{{tabIndex}} p-invalid" *ngIf="isRequiredTouched(field.name)">
                            {{ field.labelName }} is required
                        </small>
                        <small id="error-help" class="custom-fields-error-{{tabIndex}} p-invalid" *ngIf="isPatternInvalid(field.name)">
                            Please enter a valid number
                        </small>
                    </div>
                </ng-container>

                <!-- Decimal -->
                <ng-container *ngSwitchCase="'Decimal'">
                    <p-inputNumber
                        [formControlName]="field.name"
                        (ngModelChange)="onSetCustomFieldValue(field.customAttributeId, customForm.get(field.name).value)"
                        [minFractionDigits]="0" [maxFractionDigits]="(field?.formControl?.maxLengthAfterDecimal||field?.maxLengthAfterDecimal||6)"
                        (keypress)="isNumberKey($event)">
                    </p-inputNumber>
                    <div class="p-mt-1">
                        <small id="error-help" class="custom-fields-error-{{tabIndex}} p-invalid" *ngIf="isRequiredTouched(field.name)">
                            {{ field.labelName }} is required
                        </small>
                        <small id="error-help" class="custom-fields-error-{{tabIndex}} p-invalid" *ngIf="isPatternInvalid(field.name)">
                            Please enter a valid number
                        </small>
                    </div>
                </ng-container>

                <!-- Currency -->
                <ng-container *ngSwitchCase="'Currency'">
                    <p-inputNumber
                        [formControlName]="field.name" mode="decimal"
                        [prefix]="field.currencySymbol ? field.currencySymbol.trim()+ ' ' : currencySymbol + ' '"
                        [placeholder]="field.currencySymbol ? field.currencySymbol.trim() : currencySymbol"
                        (ngModelChange)="onSetCustomFieldValue(field.customAttributeId, customForm.get(field.name).value)"
                        [minFractionDigits]="0" [maxFractionDigits]="(field?.formControl?.maxLengthAfterDecimal||field?.maxLengthAfterDecimal||6)"
                        [step]="1"
                        (keypress)="isNumberKey($event)"   class="currency-input">
                    </p-inputNumber>
                    <div class="p-mt-1">
                        <small id="error-help" class="custom-fields-error-{{tabIndex}} p-invalid" *ngIf="isRequiredTouched(field.name)">
                            {{ field.labelName }} is required
                        </small>
                    </div>
                </ng-container>

                <!-- User Lookup -->
                <ng-container *ngSwitchCase="'UserLookup'">
                    <p-dropdown [options]="usersList" [placeholder]="'Select ' + field.name" [filter]="true"
                        [formControlName]="field.name" optionLabel="name" optionValue="id" appendTo="body" [showClear]="true"
                        (onChange)="onSetCustomFieldValue(field.customAttributeId, customForm.get(field.name).value)">
                    </p-dropdown>
                    <div class="p-mt-1">
                        <small id="error-help" class="custom-fields-error-{{tabIndex}} p-invalid" *ngIf="isRequiredTouched(field.name)">
                            {{ field.labelName }} is required
                        </small>
                    </div>
                </ng-container>

                <!-- Dropdown -->
                <ng-container *ngSwitchCase="'DropDownList'">
                    <p-dropdown [options]="field.formControl.pickListValues" [placeholder]="'Select ' + field.name"
                        [formControlName]="field.name" optionLabel="name" appendTo="body"
                        (onChange)="onSetCustomFieldValue(field.customAttributeId, customForm.get(field.name).value)">
                    </p-dropdown>
                    <div class="p-mt-1">
                        <small id="error-help" class="custom-fields-error-{{tabIndex}} p-invalid" *ngIf="isRequiredTouched(field.name)">
                            {{ field.labelName }} is required
                        </small>
                    </div>
                </ng-container>

                <!-- Multiple Dropdown -->
                <ng-container *ngSwitchCase="'MultipleDropDownList'">
                    <p-multiSelect [options]="field.formControl.pickListValues" [placeholder]="'Select ' + field.name"
                        [formControlName]="field.name" optionLabel="name" appendTo="body"
                        (onChange)="onSetCustomFieldValue(field.customAttributeId, customForm.get(field.name).value)">
                    </p-multiSelect>
                    <div class="p-mt-1">
                        <small id="error-help" class="custom-fields-error-{{tabIndex}} p-invalid" *ngIf="isRequiredTouched(field.name)">
                            {{ field.labelName }} is required
                        </small>
                    </div>
                </ng-container>

                <!-- CheckBox -->
                <ng-container *ngSwitchCase="'CheckBox'">
                    <ng-container *ngFor="let option of field.formControl.pickListValues">
                        <p-checkbox [value]="option.name" [formControl]="customForm?.controls[field.name]"
                            (onChange)="onSetCustomFieldValue(field.customAttributeId, customForm.get(field.name).value)">
                        </p-checkbox>
                        {{ option.name }}
                        @if(option.description){
                            <i class="pi pi-info-circle p-mr-2 info-icon-tooltip"
                               pTooltip="{{option.description}}"
                               tooltipPosition="top">
                            </i>
                        }
                    </ng-container>
                    <div class="p-mt-1">
                        <small id="error-help" class="custom-fields-error-{{tabIndex}} p-invalid" *ngIf="isRequiredTouched(field.name)">
                            {{ field.labelName }} is required
                        </small>
                    </div>
                </ng-container>

                <!-- File Upload -->
                <ng-container *ngSwitchCase="'FileUpload'">
                    <p-fileUpload customUpload="true" class="fupload" previewWidth="100" chooseLabel="Choose"
                        [showUploadButton]="false" [showCancelButton]="false" multiple="multiple" (onSelect)="onCustomUpload($event, field, 'any')">
                        <ng-template pTemplate="file"></ng-template>
                        <ng-template pTemplate="content">
                            <ng-container *ngFor="let file of uploadedFiles; let i = index;">
                                    <div class="p-fileupload-row" *ngIf="file">
                                        <button pButton icon="fa fa-download" (click)="downloadFile(file.name, file.content)"
                                            class="p-button-link p-px-0 p-py-0">
                                        </button>
                                        <ng-container *ngIf="file.name.length > 15 else splitFileName">
                                            <div [pTooltip]="file.name">
                                                {{ file.name.substring(0, 14) }} ...
                                            </div>
                                        </ng-container>
                                        <ng-template #splitFileName>
                                            <div> {{ file.name }} </div>
                                        </ng-template>
                                        <div>
                                            {{ file.size | fileSize }}
                                        </div>
                                        <div>
                                            <button icon="pi pi-times" pButton (click)="removeCustomFile(i, field)" type="button"
                                                icon="pi pi-times">
                                            </button>
                                        </div>
                                    </div>
                                </ng-container>
                        </ng-template>
                    </p-fileUpload>
                    <div class="p-mt-1">
                        <small id="error-help" class="custom-fields-error-{{tabIndex}} p-invalid" *ngIf="isRequiredTouched(field.name) && !uploadedFiles.length">
                            {{ field.labelName }} is required
                        </small>
                    </div>
                </ng-container>

                <!-- Picture -->
                <ng-container *ngSwitchCase="'Picture'">
                    <p-fileUpload customUpload="true" class="fupload" previewWidth="100" chooseLabel="Choose"
                        accept="image/*" [showUploadButton]="false" [showCancelButton]="false" multiple="multiple"
                        (onSelect)="onCustomUpload($event, field, 'image')">
                        <ng-template pTemplate="file"></ng-template>
                        <ng-template pTemplate="content">
                            <ng-container *ngFor="let picture of uploadedPictures; let i = index;">
                                <div class="p-fileupload-row p-mb-2">
                                    <button pButton icon="fa fa-download" (click)="downloadFile(picture.name, picture.content)"
                                        class="p-button-link p-px-0 p-py-0">
                                    </button>
                                    <ng-container *ngIf="picture.content && picture.content.startsWith('data') else localImage">
                                        <img src="{{ picture.content }}" width="100" alt="card" />
                                    </ng-container>
                                    <ng-template #localImage>
                                        <img [src]="picture.location" width="100" alt="card" />
                                    </ng-template>
                                    <ng-container *ngIf="picture.name.length > 15 else splitImageName">
                                        <div [pTooltip]="picture.name">
                                            {{ picture.name.substring(0, 14) }}...
                                        </div>
                                    </ng-container>
                                    <ng-template #splitImageName>
                                        <div> {{ picture.name }} </div>
                                    </ng-template>
                                    <div>
                                        {{ picture.size | fileSize }}
                                    </div>
                                    <div>
                                        <button icon="pi pi-times" pButton (click)="removeCustomPicture(i, field)" type="button"
                                            icon="pi pi-times">
                                        </button>
                                    </div>
                                </div>
                            </ng-container>
                        </ng-template>
                    </p-fileUpload>
                    <div class="p-mt-1">
                        <small id="error-help" class="custom-fields-error-{{tabIndex}} p-invalid" *ngIf="isRequiredTouched(field.name) && !uploadedPictures.length">
                            {{ field.labelName }} is required
                        </small>
                    </div>
                </ng-container>

                <!-- Radio Button -->
                <ng-container *ngSwitchCase="'RadioButton'">
                    <ng-container *ngFor="let option of field.formControl.pickListValues">
                        <p-radioButton [value]="option.name" [formControlName]="field.name"
                            (onClick)="onSetCustomFieldValue(field.customAttributeId, customForm.get(field.name).value)">
                        </p-radioButton>&nbsp; {{ option.name }}
                    </ng-container>
                    <div class="p-mt-1">
                        <small id="error-help" class="custom-fields-error-{{tabIndex}} p-invalid" *ngIf="isRequiredTouched(field.name)">
                            {{ field.labelName }} is required
                        </small>
                    </div>
                </ng-container>

                <!-- Date Picker -->
                <ng-container *ngSwitchCase="'DatePicker'">
                    <p-calendar appendTo="body" [monthNavigator]="true" [yearNavigator]="true" placeholder="mm/dd/yyyy" appendTo="body"
                        dateFormat="mm/dd/yy" yearRange="1900:2100" [showTime]="false" [formControlName]="field.name"
                        (onInput)="onSetCustomFieldValue(field.customAttributeId, customForm.get(field.name).value, true)"
                        (onSelect)="onSetCustomFieldValue(field.customAttributeId, customForm.get(field.name).value, true)">
                    </p-calendar>
                    <div class="p-mt-1">
                        <small id="error-help" class="custom-fields-error-{{tabIndex}} p-invalid" *ngIf="isRequiredTouched(field.name)">
                            {{ field.labelName }} is required
                        </small>
                    </div>
                </ng-container>

                <!-- Date Time Picker -->
                <ng-container *ngSwitchCase="'DateTimePicker'">
                    <p-calendar appendTo="body" [monthNavigator]="true" [yearNavigator]="true" placeholder="mm/dd/yy hh:mm a" appendTo="body"
                        dateFormat="mm/dd/yy" yearRange="1900:2100" [showTime]="true" [hourFormat]="12" [formControlName]="field.name"
                        (onInput)="onSetCustomFieldValue(field.customAttributeId, customForm.get(field.name).value, true)"
                        (onSelect)="onSetCustomFieldValue(field.customAttributeId, customForm.get(field.name).value, true)">
                    </p-calendar>
                    <div class="p-mt-1">
                        <small id="error-help" class="custom-fields-error-{{tabIndex}} p-invalid" *ngIf="isRequiredTouched(field.name)">
                            {{ field.labelName }} is required
                        </small>
                    </div>
                </ng-container>

                <!-- Rating -->
                <ng-container *ngSwitchCase="'Rating'">
                    <p-rating [cancel]="false" [formControlName]="field.name"
                        (onRate)="onSetCustomFieldValue(field.customAttributeId, customForm.get(field.name).value)"></p-rating>
                    <div class="p-mt-1">
                        <small id="error-help" class="custom-fields-error-{{tabIndex}} p-invalid" *ngIf="isRequiredTouched(field.name)">
                            {{ field.labelName }} is required
                        </small>
                    </div>
                </ng-container>

                <!-- Toggle Button -->
                <ng-container *ngSwitchCase="'ToggleButton'">
                    <p-toggleButton onLabel="{{ field.labelName }}" offLabel="{{ field.labelName }}"
                        [onIcon]="'pi pi-check'" [offIcon]="'pi pi-times'" iconPos="right" [formControlName]="field.name"
                        (onChange)="onSetCustomFieldValue(field.customAttributeId, customForm.get(field.name).value)">
                    </p-toggleButton>
                </ng-container>
            </ng-container>
        </div>
    </ng-container>
</form>

<!-- View custom field values -->
<ng-template #viewBlock>
    <div class="p-field p-grid p-mb-0">
        <ng-container *ngFor="let data of customDataValues">
            <ng-container *ngIf="data.value || data.value===0">

                <ng-container [ngSwitch]="data.formControlId">
                    <ng-container *ngSwitchCase="customTypes.DATE_PICKER">
                        <div class="p-col-4 p-md-2">
                            <p>
                                <strong> {{ data.labelName }}
                                    <span style="color: red;" *ngIf="data.isRequired"> * </span>
                                </strong>
                            </p>
                        </div>
                        <div class="p-col-8 p-md-4">
                            <p> {{ data.value | date:'MM/dd/yyyy' }} </p>
                        </div>
                    </ng-container>

                    <ng-container *ngSwitchCase="customTypes.DATETIMEPICKER">
                        <div class="p-col-4 p-md-2">
                            <p>
                                <strong> {{ data.labelName }}
                                    <span style="color: red;" *ngIf="data.isRequired"> * </span>
                                </strong>
                            </p>
                        </div>
                        <div class="p-col-8 p-md-4">
                            <p> {{ data.formattedValue }} </p>
                        </div>
                    </ng-container>

                    <ng-container *ngSwitchCase="customTypes.TIME">
                        <div class="p-col-4 p-md-2">
                            <p>
                                <strong> {{ data.labelName }}
                                    <span style="color: red;" *ngIf="data.isRequired"> * </span>
                                </strong>
                            </p>
                        </div>
                        <div class="p-col-8 p-md-4">
                            <p> {{ data.value | onlyTime }} </p>
                        </div>
                    </ng-container>

                    <ng-container *ngSwitchCase="customTypes.PERCENTAGE">
                        <div class="p-col-4 p-md-2">
                            <p>
                                <strong> {{ data.labelName }}
                                    <span style="color: red;" *ngIf="data.isRequired"> * </span>
                                </strong>
                            </p>
                        </div>
                        <div class="p-col-8 p-md-4">
                            <p> {{ data.value | percentageSymbol }} </p>
                        </div>
                    </ng-container>

                    <ng-container *ngSwitchCase="customTypes.CURRENCY">
                        <div class="p-col-4 p-md-2">
                            <p>
                                <strong> {{ data.labelName }}
                                    <span style="color: red;" *ngIf="data.isRequired"> * </span>
                                </strong>
                            </p>
                        </div>
                        <div class="p-col-8 p-md-4">
                            <p> {{ data.value | customNumberFormat:maximumFractionDigits | currencySymbol: null : data?.currencySymbol }} </p>
                        </div>
                    </ng-container>

                    <ng-container *ngSwitchCase="customTypes.USERLOOKUP">
                        <div class="p-col-4 p-md-2">
                            <p>
                                <strong> {{ data.labelName }}
                                    <span style="color: red;" *ngIf="data.isRequired"> * </span>
                                </strong>
                            </p>
                        </div>
                        <div class="p-col-8 p-md-4">
                            <p> {{ data.userLookupValue }} </p>
                        </div>
                    </ng-container>

                    <ng-container *ngSwitchCase="customTypes.BARCODE">
                        <div class="p-col-4 p-md-2">
                            <p>
                                <strong> {{ data.labelName }}
                                    <span style="color: red;" *ngIf="data.isRequired"> * </span>
                                </strong>
                            </p>
                        </div>
                        <div class="p-col-8 p-md-4">
                            <p>
                                <ngx-barcode6 [bc-value]="data.value"
                                    [bc-display-value]="true" [bc-height]="35"
                                    [bc-font-size]="13" [bc-width]="1">
                                </ngx-barcode6>
                            </p>
                        </div>
                    </ng-container>

                    <ng-container *ngSwitchCase="customTypes.URL">
                        <div class="p-col-4 p-md-2">
                            <p>
                                <strong> {{ data.labelName }}
                                    <span style="color: red;" *ngIf="data.isRequired"> * </span>
                                </strong>
                            </p>
                        </div>
                        <div class="p-col-8 p-md-4">
                            <p>
                                <a href="{{data.value | url}}" target="_blank">{{ data.value }}</a>
                            </p>
                        </div>
                    </ng-container>

                    <ng-container *ngSwitchCase="customTypes.MULTI_LINE">
                        <div class="p-col-12">
                            <div class="p-grid p-py-2">
                                <div class="p-col-2">
                                    <p>
                                        <strong> {{ data.labelName }}
                                            <span style="color: red;" *ngIf="data.isRequired"> * </span>
                                        </strong>
                                    </p>
                                </div>
                                <div class="p-col-10" style="white-space: pre-line;">
                                    <p> {{ data.value }} </p>
                                </div>
                            </div>
                        </div>
                    </ng-container>

                    <ng-container *ngSwitchCase="customTypes.RICHTEXT">
                        <div class="p-col-12">
                            <div class="p-grid p-py-2">
                                <div class="p-col-2">
                                    <p>
                                        <strong> {{ data.labelName }}
                                            <span style="color: red;" *ngIf="data.isRequired"> * </span>
                                        </strong>
                                    </p>
                                </div>
                                <div class="p-col-10 ql-editor">
                                    <div [innerHTML]="rawHTML(data.value)"></div>
                                </div>
                            </div>
                        </div>
                    </ng-container>

                    <ng-container *ngSwitchCase="customTypes.PICTURE">
                        <ng-container *ngIf="data?.value?.length>0">
                            <div class="p-col-4 p-md-2">
                                <p>
                                    <strong> {{ data.labelName }} <span style="color: red;" *ngIf="data.isRequired"> * </span></strong>
                                </p>
                            </div>
                            <div class="p-col-8 p-md-4">
                                <div *ngFor="let el of data.value" class="p-mb-2" style="display: flex; align-items: center; gap: 1rem">
                                    <img [src]="el.content" height="50" alt="card" />

                                    <div class="p-d-flex p-ai-center p-mb-1 p-mt-1">
                                        <button pButton icon="fa fa-download"  (click)="downloadFile(el.name,el.content)"
                                            class="p-button-link p-px-0 p-py-0 p-mr-2">
                                        </button>
                                        <div [pTooltip]="el.name">
                                            {{ el.name | shorten:15 }} ({{ el.sizeInKb + ' KB' }})
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-container>

                    </ng-container>

                    <ng-container *ngSwitchCase="customTypes.FILE">
                        <ng-container *ngIf="data?.value?.length>0">
                            <div class="p-col-4 p-md-2">
                                <p>
                                    <strong> {{ data.labelName }} <span style="color: red;" *ngIf="data.isRequired"> * </span></strong>
                                </p>
                            </div>
                            <div class="p-col-8 p-md-4">

                                <div *ngFor="let el of data.value" [pTooltip]="el.name">
                                    <div class="p-d-flex p-ai-center p-mb-1 p-mt-1">
                                        <button pButton icon="fa fa-download"  (click)="downloadFile(el.name,el.content)"
                                            class="p-button-link p-px-0 p-py-0 p-mr-2">
                                        </button>
                                        <div [pTooltip]="el.name">
                                            {{ el.name | shorten:15 }} ({{ el.sizeInKb + ' KB' }})
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    </ng-container>

                    <ng-container *ngSwitchDefault>
                        <div class="p-col-4 p-md-2">
                            <p>
                                <strong> {{ data.labelName }} <span style="color: red;" *ngIf="data.isRequired"> * </span></strong>
                            </p>
                        </div>
                        <div class="p-col-8 p-md-4" style="white-space: pre-line;">
                            <p> {{ data.value }} </p>
                        </div>
                    </ng-container>
                </ng-container>
            </ng-container>
        </ng-container>
    </div>
</ng-template>
